import { FormEvent } from 'react';
import { Button, ButtonGroup, Col, ControlLabel, Form, FormGroup, Row, Well, FormControl } from 'react-bootstrap';
import { ICenterBase, ICenterFiveStarSurveyType } from '@nkr/models/index';

interface IProps {
    startDate: string,
    endDate: string,
    isAdmin: boolean,
    centerId: number,
    includeDash: boolean,
    includeNkr: boolean,
    centerList: ICenterBase[],
    onFilterChange: (startDate: string, endDate: string, centerId: number,) => void
    onFilter: () => void
}

const Filter = (props: IProps) => {
    const handleStartDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let startDate = e.currentTarget.value;

        props.onFilterChange(startDate, props.endDate, props.centerId);
    };

    const handleEndDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let endDate = e.currentTarget.value;

        props.onFilterChange(props.startDate, endDate, props.centerId);
    };

    const handleCenterChange = (e: React.ChangeEvent<FormControl & HTMLSelectElement>) => {
        let centerId = parseInt(e.currentTarget.value);

        props.onFilterChange(props.startDate, props.endDate, centerId);
    }

    return (
        <Well style={{ marginBottom: 5, paddingTop: 9.5, paddingBottom: 9.5 }}>
            <Row>
                <Col xs={12} lg={3} style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ marginRight: 5 }}>Start&nbsp;Date:&nbsp;</div>
                    <FormControl
                        type='date'
                        name='startDate'
                        value={props.startDate}
                        onChange={handleStartDateChange}
                    />
                </Col>

                <Col xs={12} lg={3} style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ marginRight: 5 }}>End&nbsp;Date:</div>
                    <FormControl
                        type='date'
                        name='endDate'
                        value={props.endDate}
                        onChange={handleEndDateChange}
                    />
                </Col>

                {props.isAdmin && (
                    <Col xs={12} lg={3} style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ marginRight: 5 }}>Center:</div>
                        <FormControl
                            componentClass="select"
                            style={{ width: "initial" }}
                            value={props.centerId}
                            onChange={handleCenterChange}
                        >
                            <option value={0}>- ALL CENTERS -</option>
                            {props.centerList.map((center, index) =>
                                <option key={index} value={center.id}>{center.alias}</option>
                            )}
                        </FormControl>
                    </Col>
                )}

                <Col xs={12} lg={2} style={{ float: 'right' }}>
                    <Button bsStyle='primary' style={{ width: '100%' }} onClick={props.onFilter}>Filter</Button>
                </Col>
            </Row>
        </Well>
    );
}

export default Filter;
